import { call, put, takeLatest } from "@redux-saga/core/effects";
// import { ConfigTableParser } from "./ConfigParser";
import { VehicleApiData } from "./VehicleApi";
import { VehicleConstant } from "./VehicleConstant";
import { VehicleParser } from "./VehicleParser";

function* getVehicleData({ payload }) {
  try {
    const {
      page
    
    } = payload;
    yield put({ type: VehicleConstant.VEHICLE_REQUEST });
    const res = yield call(VehicleApiData.getVehicleData, {
      page,
     
    });

    const result = VehicleParser.getVehicleParser(res);
    yield put({
      type: VehicleConstant.VEHICLE_RESPONSE,
      payload: result,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: VehicleConstant.VEHICLE_RESPONSE,
      payload: [],
    });
  }
}

function* postVehicleData(payload) {
  try {
    yield put({
      type: VehicleConstant.ADD_VEHICLE_REQUEST,
    });
    const res = yield call(VehicleApiData.postVehicleData, payload.payload);

    yield put({
      type: VehicleConstant.ADD_VEHICLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: VehicleConstant.ADD_VEHICLE_RESPONSE,
      payload: [],
    });
  }
}

function* getVheicleDropdownData() {

  try {
    yield put({ type: VehicleConstant.VEHICLE_DROPDOWN_REQUEST });

    const res = yield call(VehicleApiData.getVehicleDropdownData);
   
    const result = VehicleParser.getVehicleDropdownData(res);

    yield put({
      type: VehicleConstant.VEHICLE_DROPDOWN_RESPONSE,
      payload: result,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: VehicleConstant.VEHICLE_DROPDOWN_RESPONSE,
    });
  }
}

function* postVehicleBulkData(payload) {
  try {
    yield put({
      type: VehicleConstant.POST_VEHICLE_BULK_REQUEST,
    });
    const res = yield call(VehicleApiData.postVehicleBulkApi);
    const formData = VehicleParser.postVehilceBuikParse(res);

    yield put({
      type: VehicleConstant.POST_VEHICLE_BULK_RESPONSE,
      payload: formData,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: VehicleConstant.POST_VEHICLE_BULK_RESPONSE,
      payload: [],
    });
  }
}
function* getMenufacturerdropdownDataId(id) {

  try {
    yield put({
      type: VehicleConstant.VEHICLE_GET_MENUFATURER_REQUEST,
    });
    const res = yield call(VehicleApiData.VehicleMenufaturerbyIdapi,  id );
    yield put({
      type: VehicleConstant.VEHICLE_GET_MENUFATURER_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: VehicleConstant.VEHICLE_GET_MENUFATURER_RESPONSE,
      payload: {},
    });
  }
}

function* getModeldropdownDataId(id) {

  try {
    yield put({
      type: VehicleConstant.VEHICLE_MODEL_REQUEST,
    });
    const res = yield call(VehicleApiData.VehicleModelbyIdapi,  id );
    yield put({
      type: VehicleConstant.VEHICLE_MODEL_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: VehicleConstant.VEHICLE_MODEL_RESPONSE,
      payload: {},
    });
  }
}
function* getVheicleTypesDropdownData() {

  try {
    yield put({ type: VehicleConstant.VEHICLE_TYPES_REQUEST });

    const res = yield call(VehicleApiData.getVehicleTypeData);
   
    // const result = VehicleParser.getVehicleDropdownData(res);

    yield put({
      type: VehicleConstant.VEHICLE_TYPES_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: VehicleConstant.VEHICLE_TYPES_RESPONSE,
    });
  }
}
// function* getVheicleSubTypesDropdownData(id) {
//   console.log('feufheufe',id.payload);
  

//   try {
//     yield put({ type: VehicleConstant.VEHICLE_SUB_TYPES_REQUEST });

//     const res = yield call(VehicleApiData.getVehicleSubTypeData, id.payload);
   
//     // const result = VehicleParser.getVehicleDropdownData(res);

//     yield put({
//       type: VehicleConstant.VEHICLE_SUB_TYPES_RESPONSE,
//       payload: res,
//     });
//   } catch (e) {
//     console.log("Error", e);
//     yield put({
//       type: VehicleConstant.VEHICLE_SUB_TYPES_RESPONSE,
//     });
//   }
// }

function* getVheicleSubTypesDropdownData(id) {
  console.log('dwhuwgdw',id);
  

  try {
    yield put({ type: VehicleConstant.VEHICLE_SUB_TYPES_REQUEST });

    const res = yield call(VehicleApiData.getVehicleSubTypeData, id.payload);

    yield put({
      type: VehicleConstant.VEHICLE_SUB_TYPES_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: VehicleConstant.VEHICLE_SUB_TYPES_RESPONSE,
      payload: {},
    });
  }
}



function* getVariantropdownDataId(payload) {
  // const { id } = payload;

  try {
    yield put({
      type: VehicleConstant.VEHICLE_VARIANT_DROPDOWN_REQUEST,
    });
    const res = yield call(VehicleApiData.VehicleVariantapi, payload);
    yield put({
      type: VehicleConstant.VEHICLE_VARIANT_DROPDOWN_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: VehicleConstant.VEHICLE_VARIANT_DROPDOWN_RESPONSE,
      payload: {},
    });
  }
}
export function* VehcileDataSaga() {
  yield takeLatest(VehicleConstant.VEHICLE_SAGA, getVehicleData);
  yield takeLatest(VehicleConstant.ADD_VEHICLE_SAGA, postVehicleData);
  yield takeLatest(
    VehicleConstant.VEHICLE_DROPDOWN_SAGA,
    getVheicleDropdownData
  );
  yield takeLatest(VehicleConstant.POST_VEHICLE_BULK_SAGA, postVehicleBulkData);
  yield takeLatest(VehicleConstant.VEHICLE_MODEL_SAGA, getModeldropdownDataId);
  yield takeLatest(VehicleConstant.VEHICLE_VARIANT_DROPDOWN_SAGA, getVariantropdownDataId);
  yield takeLatest(VehicleConstant.VEHICLE_TYPES_SAGA, getVheicleTypesDropdownData);
  yield takeLatest(VehicleConstant.VEHICLE_GET_MENUFATURER_SAGA, getMenufacturerdropdownDataId);
  yield takeLatest(VehicleConstant.VEHICLE_SUB_TYPES_SAGA, getVheicleSubTypesDropdownData);
}
